module.exports = __webpack_public_path__ + "static/media/Aneri.ba87910c.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/company/team/images/Aneri.jpeg
// module id = 1759
// module chunks = 147